import { useState } from 'react';

import { useUsers } from '@/models/user';
import { USERS_PER_PAGE, UsersTable } from '@/routes/SettingsBeta/components/UsersTable';

export const MembersSection = ({ entity }: { entity: { id: string } }) => {
  const [page, setPage] = useState(1);

  const {
    data: { users, meta } = {},
    isLoading,
    isPlaceholderData,
    isError,
  } = useUsers(
    { limit: USERS_PER_PAGE, offset: (page - 1) * USERS_PER_PAGE, entityIds: [entity.id] },
    { keepPreviousData: true }
  );

  return (
    <UsersTable
      users={users ?? []}
      isLoading={isLoading || !!isPlaceholderData}
      isError={isError}
      page={page}
      onPageChange={setPage}
      count={meta?.count}
      entity={entity}
    />
  );
};
